import { render, staticRenderFns } from "./TabVertical.vue?vue&type=template&id=96da28a8"
import script from "./TabVertical.vue?vue&type=script&lang=js"
export * from "./TabVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/srv/app/components/button/Button.vue').default,Picture: require('/srv/app/components/picture/Picture.vue').default,Markdown: require('/srv/app/components/markdown/Markdown.vue').default})
